import React, { useReducer } from 'react';

import { useToasts } from 'react-toast-notifications'
import { successToast, errorToast } from '../../utils/ToastUtil'

import BenefitsContext from './BenefitsContext'
import BenefitsReducer from './BenefitsReducer'

import { 
    LOADING, 
    GET_BENEFITS,
    SAVE_BENEFIT,
    CACHE_BENEFIT,
    CLEAN_BENEFIT,
    UPDATE_BENEFIT,
    DELETE_BENEFIT
} from "../../types";

import {postBenefit, patchBenefit, deleteBenefit} from "../../http_services/admin/benefit"
import {allBenefits} from "../../http_services/benefits"

const LoginState = (props) => {
    const { addToast } = useToasts();

    const initialState = {
        loading: false,
        benefits: [],
        benefit: {}
    }

    const [state, dispatch] = useReducer(BenefitsReducer, initialState);

    const loadBenefits = async() => {
        try{
            loading(); 
            const benefits = await allBenefits();
            dispatch({
                type: GET_BENEFITS,
                payload: benefits.data
            });
            loading();
        } catch(err) {
            loading();
            addToast('Error al tratar de obtener la data', errorToast());
        }
    }

    const saveBenefit = async (benefit) => {
        try{
            loading(); 
            const data = await postBenefit(benefit);
            dispatch({
                type: SAVE_BENEFIT,
                payload: data.data
            });
            loading();
            addToast('Beneficio Registrado con éxito', successToast());
            return data;
        } catch(err) {
            loading();
            addToast('Error al Registrar Beneficio', errorToast());
            return null;
        }
    }
   
    const uploadBenefit = async (id, benefit) => {
        try{
            loading(); 
            const data = await patchBenefit(id, benefit);
            dispatch({
                type: UPDATE_BENEFIT,
                payload: data.data
            });
            loading();
            addToast('Beneficio Actualizado con éxito', successToast());
            return data;
        } catch(err) {
            loading();
            addToast('Error al Actualizar Beneficio', errorToast());
            return null;
        }
    }

    const dropBenefit = async (id) => {
        try{
            loading(); 
            const data = await deleteBenefit(id);
            dispatch({
                type: DELETE_BENEFIT,
                payload: id
            });
            loading();
            addToast('Beneficio Eliminado con éxito', successToast());
            return data;
        } catch(err) {
            loading();
            addToast('Error al tratar de Eliminar el Beneficio', errorToast());
            return null;
    }
    }

    const cacheBenefit = (benefit) => {    
        dispatch({
            type: CACHE_BENEFIT,
            payload: benefit
        });
    }

    const cleanBenefit = () => {    
        dispatch({
            type: CLEAN_BENEFIT
        });
    }
    
    const loading = () => {
        dispatch({
          type: LOADING
        });
      }

    return ( 
        <BenefitsContext.Provider
            value={{
                loading: state.loading,
                benefits: state.benefits,
                benefit: state.benefit,
                cacheBenefit: cacheBenefit,
                cleanBenefit: cleanBenefit,
                saveBenefit: saveBenefit,
                uploadBenefit: uploadBenefit,
                deleteBenefit: dropBenefit,
                loadBenefits: loadBenefits
            }}
        >
            {props.children}
        </BenefitsContext.Provider>
     );
}
 
export default LoginState;